import React from 'react';
import { Sparkles, Loader2 } from 'lucide-react';
import { eventBus, EventNames } from '../../../utils/eventBus';
import type { DocumentPanelTab } from './types';

interface SuggestionIndicatorProps {
  count: number;
  isLoading: boolean;
  disabled?: boolean;
}

/**
 * Compact badge in InputToolbar that shows suggestion count.
 * Visible only in Smart mode when suggestions > 0 or loading.
 * Click opens the document panel on the "Sugeridos" tab.
 */
const SuggestionIndicator: React.FC<SuggestionIndicatorProps> = ({
  count,
  isLoading,
  disabled = false,
}) => {
  if (count === 0 && !isLoading) return null;

  const handleClick = () => {
    const tab: DocumentPanelTab = 'seleccionados';
    eventBus.emit(EventNames.OPEN_DOCUMENT_PANEL, { tab });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className="inline-flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-medium text-nb-accent/80 hover:text-nb-accent hover:bg-nb-accent/5 border border-nb-accent/20 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
      title={
        isLoading
          ? 'Buscando documentos sugeridos...'
          : `${count} documento${count !== 1 ? 's' : ''} sugerido${count !== 1 ? 's' : ''}`
      }
      aria-label={isLoading ? 'Buscando sugerencias' : `${count} sugerido${count !== 1 ? 's' : ''}`}
    >
      {isLoading ? <Loader2 className="w-3 h-3 animate-spin" /> : <Sparkles className="w-3 h-3" />}
      <span>{isLoading ? 'Buscando...' : `${count} sugerido${count !== 1 ? 's' : ''}`}</span>
    </button>
  );
};

export default SuggestionIndicator;
